export default "__VITE_ASSET__1d25948b__"